
var stache = require('can/view/stache/stache');
module.exports = stache("<div class=\"c-twitter-embed\">\r\n\r\n</div>");